'use strict';

require('./list');
require('./item');
require('./dialog');

angular.module('dash.nav.left.overlays', [
  'dash.nav.left.overlays.list',
  'dash.nav.left.overlays.item',
  'dash.nav.left.overlays.dialog'
]);


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/overlays/index.js